export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"charset":"utf-8"},{"name":"theme-color","content":"#1C1917"},{"name":"apple-mobile-web-app-title","content":"ClockTracker"},{"name":"apple-mobile-web-app-capable","content":"yes"}],"link":[{"rel":"stylesheet","href":"/index.css"},{"rel":"icon","type":"image/png","href":"/logo-ct-sm.png"},{"rel":"apple-touch-icon","href":"/logo-ct-sm.png"},{"rel":"apple-touch-startup-image","href":"/logo-ct-sm.png"},{"rel":"apple-touch-startup-image","href":"/launch-640x1136.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"/launch-750x1294.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"/launch-1242x2148.png","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"/launch-1125x2436.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"/launch-1536x2048.png","media":"(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"/launch-1668x2224.png","media":"(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"/launch-2048x2732.png","media":"(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)"}],"style":[],"script":[{"data-goatcounter":"https://clocktracker.goatcounter.com/count","async":true,"src":"//gc.zgo.at/count.js"},{"innerHTML":"\n          if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {\n            document.documentElement.classList.add('dark')\n          } else {\n            document.documentElement.classList.remove('dark')\n          }\n          "}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1, viewport-fit=cover","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true